
import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const getCurrency = async (query) => {
  try {
    let res = await Api.get("/currency", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getCurrencyById = async (id) => {
  try {
    let res = await Api.get("/currency/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const createCurrency = async (data) => {
  try {
    let res = await Api.post("/currency", data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const updateCurrency = async (id, data) => {
  try {
    let res = await Api.patch("/currency/" + id, data);

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const deleteCurrency = async (id) => {
  try {
    let res = await Api.delete("/currency/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};
